var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotate10L1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "56.69px",
    height: "56.69px",
    viewBox: "0 0 56.69 56.69",
    enableBackground: "new 0 0 56.69 56.69",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.308,31.365"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.692,28.347c0,15.655-12.69,28.348-28.347,28.348C12.691,56.695,0,44.002,0,28.347S12.691,0,28.346,0 C44.002,0,56.692,12.692,56.692,28.347"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M9.212,25.977 c1.027-8.313,7.433-15.291,16.119-16.667c10.514-1.665,20.389,5.509,22.053,16.023c1.666,10.514-5.508,20.389-16.021,22.055 c-1.033,0.164-2.061,0.242-3.074,0.24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "13.065,24.911 9.288,31.365 5.587,24.866  "
  })))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.929,28.348c0,2.435,1.977,4.417,4.416,4.417s4.418-1.982,4.418-4.417c0-2.446-1.979-4.421-4.418-4.421 C25.905,23.927,23.929,25.903,23.929,28.348z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate10L1);
export default __webpack_public_path__ + "static/media/rotate_10_l_1.363c7b6966ec183989a82424dfd0ce9a.svg";
export { ForwardRef as ReactComponent };